class TGFOptionsCartEdit extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.addEventListener('click', event => {
      if (event.target.closest('[data-options-edit-open]')) this.openEditor();
    }, { signal: this.controller.signal });
  }

  disconnectedCallback() { this.controller?.abort(); }

  async openEditor() {
    if (this.busy) return;
    const config = JSON.parse(this.querySelector('[data-options-edit-config]').textContent);
    const button = this.querySelector('button');
    const previousLabel = button.textContent;
    this.busy = true;
    button.disabled = true;
    button.textContent = config.loading;
    let dialog;
    try {
      const url = new URL(config.url, location.origin);
      if (url.origin !== location.origin) throw new Error('invalid product origin');
      url.search = '';
      url.hash = '';
      const response = await fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(15000) });
      if (!response.ok) throw new Error('product response unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const form = html.querySelector('tgf-options-personalizer');
      const enhancerModules = [...form?.querySelectorAll('script[type=module][src]') || []].map(node => node.getAttribute('src'));
      for (const link of html.querySelectorAll('link[rel=stylesheet]')) {
        if (/\/tgf-(?:options|collar-preview|tag-photo-form|keychain-photo-form|jewelry-photo-form|wallet-photo-form|mug-photo-form)\.css/.test(link.href) && !document.querySelector('link[href="' + CSS.escape(link.href) + '"]')) document.head.append(link.cloneNode(true));
      }
      if (!form) throw new Error('native product form unavailable');
      const tagConfig = JSON.parse(form.querySelector('[data-options-config]').textContent);
      const instance = `edit-${crypto.randomUUID()}`;
      const ids = new Map([...form.querySelectorAll('[id]')].map(node => [node.id, `${node.id}-${instance}`]));
      for (const node of form.querySelectorAll('[id]')) node.id = ids.get(node.id);
      for (const node of form.querySelectorAll('[for],[aria-labelledby],[aria-describedby]')) {
        for (const attr of ['for','aria-labelledby','aria-describedby']) {
          if (node.hasAttribute(attr)) node.setAttribute(attr, node.getAttribute(attr).split(/\s+/).map(id => ids.get(id) || id).join(' '));
        }
      }
      for (const input of form.querySelectorAll('input[type=radio]')) input.name += `-${instance}`;
      if (Number(tagConfig.variantId) !== Number(config.line.variant_id)) throw new Error('cart variant mismatch');
      await import(config.moduleUrl);
      dialog = document.createElement('dialog');
      dialog.className = 'tgf-tag-editor';
      const header = document.createElement('div');
      header.className = 'tgf-tag-editor__header';
      const title = document.createElement('h2');
      title.id = `TgfTagEdit-${crypto.randomUUID()}`;
      title.textContent = config.title;
      dialog.setAttribute('aria-labelledby', title.id);
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'tgf-tag-editor__close';
      close.textContent = '×';
      close.setAttribute('aria-label', config.close);
      close.addEventListener('click', () => dialog.close());
      header.append(title, close);
      const body = document.createElement('div');
      body.className = 'tgf-tag-editor__body';
      body.append(form);
      dialog.append(header, body);
      dialog.addEventListener('close', () => { dialog.remove(); button.isConnected && button.focus(); });
      dialog.addEventListener('tgf-options-saved', () => dialog.close());
      document.body.append(dialog);
      form.configureEdit(config.line, config.save);
      await Promise.all(enhancerModules.map(url => import(url)));
      form.configureEdit(config.line, config.save);
      dialog.showModal();
      form.querySelector('input:checked, input')?.focus({ preventScroll: true });
    } catch (error) {
      console.warn('[tgf-options-cart-edit]', error.name, error.message);
      dialog?.remove();
      this.querySelector('[data-options-edit-error]').textContent = config.error;
    } finally {
      this.busy = false;
      button.disabled = false;
      button.textContent = previousLabel;
    }
  }
}

if (!customElements.get('tgf-options-cart-edit')) customElements.define('tgf-options-cart-edit', TGFOptionsCartEdit);
